import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { Col, ControlLabel, FormControl, Row } from 'react-bootstrap';
import { Box, Button, DataTable, Loader } from '../../../../common/components';
import Select from 'react-select';
import selectTheme from '../../../../helpers/selectTheme';
import formatDateTime from '../../../../helpers/formatDateTime';
import { applyFilter } from '../../../../common/components/DataTable/redux/dataTableActions';
import { actions } from '../../redux/sourceTypeActions';
import { connect } from 'react-redux';
import { uniqBy } from 'lodash';
import { InternalButtonBar } from '../../../layout/components';
import { bindActionCreators } from 'redux';

/********************
 Source DataTable
 *********************/

class Sources extends Component {
  constructor(props) {
    super(props);
    this.handleSearchUpdate = this.handleSearchUpdate.bind(this);
  }

  componentWillMount() {
    const { actions } = this.props;
    actions.setSourceTypes(['filter[source_type]=Direct']);
  }
  handleRowClick(row) {
    this.props.dispatch(push('/admin/sources/' + row.id));
  }

  handleStatusFilterUpdate(option) {
    this.props.dispatch(
      applyFilter('sources', 'filter[status]', option ? option.value : ''),
    );
  }

  handleSourceTypeFilterUpdate(option) {
    this.props.dispatch(
      applyFilter('sources', 'filter[source_type.name]', option ? option.value : ''),
    );
  }

  handleSearchUpdate(event) {
    this.props.dispatch(applyFilter('sources', 'filter[name]', event.target.value));
  }

  render() {
    const { sourceTypes } = this.props;

    if (!sourceTypes) {
      return <Loader />;
    }

    const sourceTypeOptions = uniqBy(sourceTypes.data, 'attributes.name').map(
      (sourceType) => {
        return { label: sourceType.attributes.name, value: sourceType.attributes.name };
      },
    );
    return (
      <Box>
        <Row className="filter-container">
          <Col sm={4}>
            <ControlLabel>Search</ControlLabel>
            <FormControl onChange={this.handleSearchUpdate} />
          </Col>
          <Col sm={4}>
            <ControlLabel>Status</ControlLabel>
            <Select
              theme={(theme) => selectTheme(theme)}
              options={[
                { value: 'active', label: 'Active' },
                { value: 'inactive', label: 'Inactive' },
              ]}
              onChange={(option) => this.handleStatusFilterUpdate(option)}
              isClearable
            />
          </Col>
          <Col sm={4}>
            <ControlLabel>Source Group</ControlLabel>
            <Select
              theme={(theme) => selectTheme(theme)}
              options={sourceTypeOptions}
              onChange={(option) => this.handleSourceTypeFilterUpdate(option)}
              isClearable
            />
          </Col>
        </Row>

        <DataTable
          source="/sources"
          name="sources"
          //autoFilters={[{ type: 'filter[source_type.source_type]', value: 'Direct' }]}
          showTotal
          onRowSelect={this.handleRowClick.bind(this)}
        >
          <TableHeaderColumn dataField="id" isKey hidden />

          <TableHeaderColumn dataField="name" dataSort width={'250px'}>
            Name
          </TableHeaderColumn>

          <TableHeaderColumn dataField="source_type" dataSort width={'250px'}>
            Source Group
          </TableHeaderColumn>

          <TableHeaderColumn dataField="status" dataSort width={'180px'}>
            Status
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="created_at"
            dataFormat={formatDateTime}
            width={'180px'}
          >
            Created Date
          </TableHeaderColumn>
        </DataTable>

        <Row>
          <Col sm={12}>
            <InternalButtonBar
              buttons={[
                {
                  permissions: ['marketing.source_create'],
                  button: (
                    <Button
                      link={true}
                      to="/admin/sources/new"
                      className="pull-right"
                      bsStyle="primary"
                      label="new source"
                    />
                  ),
                },
              ]}
            />
          </Col>
        </Row>
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    sourceTypes: state.source.sourceTypes,
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
    dispatch,
  }),
)(Sources);
